import { render } from "./avisos.vue?vue&type=template&id=7e0cddbe&scoped=true"
import script from "./avisos.vue?vue&type=script&lang=js"
export * from "./avisos.vue?vue&type=script&lang=js"

import "./avisos.vue?vue&type=style&index=0&id=7e0cddbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0cddbe"]])

export default __exports__